var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature1Svg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7627 24.2032C41.1275 27.2154 46.8 34.4688 46.8 41.0031C46.8 47.6314 39.6299 53.0031 32.4 53.0031C25.1701 53.0031 18 47.6314 18 41.0031C18 34.4688 23.6725 27.2154 28.0373 24.2032L24.72 16.2949C24.5864 16.0617 24.5033 15.8031 24.476 15.5358C24.4487 15.2684 24.4778 14.9983 24.5614 14.743C24.6451 14.4876 24.7814 14.2526 24.9616 14.0532C25.1418 13.8539 25.3618 13.6946 25.6075 13.5856C30.0165 12.1381 34.7728 12.1381 39.1819 13.5856C39.4284 13.6935 39.6495 13.8521 39.8308 14.051C40.0121 14.2499 40.1496 14.4848 40.2343 14.7402C40.319 14.9957 40.349 15.2661 40.3224 15.534C40.2958 15.8018 40.2132 16.0611 40.08 16.2949L36.7627 24.2032Z",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6367 24.2031H36.3621",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16 51.4039C9.6 51.4039 8 45.0039 8 40.494C8.09422 37.8514 8.84092 35.2731 10.1735 32.9891C11.5061 30.7051 13.3832 28.7863 15.6373 27.4039L12.9408 23.5148C12.7746 23.2749 12.6772 22.994 12.6592 22.7027C12.6412 22.4113 12.7032 22.1206 12.8386 21.862C12.9739 21.6034 13.1775 21.3867 13.4271 21.2355C13.6768 21.0842 13.963 21.0041 14.2549 21.0039H19.2",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4352 44.1371C28.8971 44.7442 29.4985 45.231 30.1885 45.5563C30.8785 45.8816 31.6367 46.0358 32.3989 46.0059C34.8288 46.0059 36.8 44.5275 36.8 42.7035C36.8 40.8795 34.8288 39.4054 32.3989 39.4054C29.9691 39.4054 28 37.927 28 36.103C28 34.279 29.9712 32.8027 32.3989 32.8027C33.1611 32.7718 33.9194 32.9254 34.6095 33.2504C35.2996 33.5754 35.901 34.0622 36.3627 34.6694",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3984 46.0059V48.2032",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3984 30.6035V32.803",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M48.0008 51.4039C54.4008 51.4039 56.0008 45.0039 56.0008 40.494C55.9066 37.8514 55.1599 35.2731 53.8273 32.9891C52.4947 30.7051 50.6176 28.7863 48.3634 27.4039L51.06 23.5148C51.2262 23.2749 51.3235 22.994 51.3416 22.7027C51.3596 22.4113 51.2976 22.1206 51.1622 21.862C51.0268 21.6034 50.8233 21.3867 50.5737 21.2355C50.324 21.0842 50.0377 21.0041 49.7458 21.0039H44.8008",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1Svg);
export default __webpack_public_path__ + "static/media/feature1SVG.9d5c847f9941b6b667801e0903ab63e0.svg";
export { ForwardRef as ReactComponent };